module.exports = __webpack_public_path__ + "img/googlereviewslogo.9118e24a.png";